export default "__VITE_ASSET__jQxCGzjm__"